import { checkIfSelfPaySource } from 'src/participant/participantUtils'
import { useGetAdvancedParticipantQuery } from '../../../advancedParticipant.generated'

export const useSelfPay = (uid: string) => {
  const { data, loading } = useGetAdvancedParticipantQuery({ variables: { uid } })
  const details = data?.patient?.details
  const source = details && typeof details === 'object' && !Array.isArray(details) ? details.source : undefined

  return { loading, isSelfPay: !loading && checkIfSelfPaySource(typeof source === 'string' ? source : undefined) }
}
